import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SearchService {
    // NOTE: null instead of '' so the search page doesn't initially do a search
    // of '' for other search terms
    searchTerm: BehaviorSubject<string> = new BehaviorSubject(null);
}
